export default {
  title: "Rejecting Work",
  content_confirm:
    "Please confirm that you want to <span class='text-error text-weight-bold'>Reject</span> this <span class='text-info text-weight-bold'>Performed Work</span>.",
  content_issue_one:
    "The <span class='text-info text-weight-bold'>Performed Work</span> has associated <span class='text-weight-bold'>Raised</span> <span class='text-info text-weight-bold'>Issues</span>.",
  content_issue_two: "They will remain open by default.",
  content_issue_three:
    "Tick the box to mark them all as <span class='text-info text-weight-bold'>Closed Without Correction</span>.",
  checkbox_content:
    "Close raised <span class='text-info text-weight-bold'>Issues</span> without <span class='text-info text-weight-bold'>Correction</span>",
  content_undone: "rejecting work cannot be undone",
  input_label: "Rejection Comment",
}
